import { DialogOverlay } from '@wonderful/wwc/dist/src/common/Dialog/DialogOverlay';
import { DialogContent } from '@wonderful/wwc/dist/src/common/Dialog/DialogContent';
import Section from '@wonderful/wwc/dist/src/common/Section/Section';

import { PopupProps } from './Popup.types';

import Button from '@/components/common/Button/Button';
import styles from './Popup.module.scss';

function Popup(props: PopupProps) {
  const {
    label,
    description,
    isPopupOpen,
    setIsPopupOpen,
    redirectLink,
    cancelBtnText,
    acceptBtnText,
  } = props;

  if (!isPopupOpen) {
    return null;
  }

  return (
    <DialogOverlay isOpen={isPopupOpen} onDismiss={() => setIsPopupOpen(false)}>
      <DialogContent
        aria-labelledby="popup-heading"
        ariaLabel="Popup Dialog"
        isOpen={isPopupOpen}
      >
        <Section id="popup-section" className={styles.popupContainer}>
          <button
            className={styles.closePopup}
            aria-label="Close Popup"
            onClick={() => setIsPopupOpen(false)}
            onTouchEnd={() => setIsPopupOpen(false)}
          >
            <span id={styles.close}>
              <span />
            </span>
          </button>
          <div className={styles.popupContentWrapper}>
            <h2 id="popup-heading" className={styles.popupLabel}>
              {label}
            </h2>
            <p className={styles.popupDescription}>{description}</p>

            <div className={styles.buttonContainer}>
              <div className={styles.buttonWrapper}>
                <Button
                  as="button"
                  design="round"
                  className={styles.popupButton}
                  onClick={() => setIsPopupOpen(false)}
                >
                  {cancelBtnText}
                </Button>
              </div>
              <div className={styles.buttonWrapper}>
                <Button
                  as="button"
                  design="round"
                  className={styles.popupButton}
                  onClick={() => {
                    open(redirectLink);
                    setIsPopupOpen(false);
                  }}
                >
                  {acceptBtnText}
                </Button>
              </div>
            </div>
          </div>
        </Section>
      </DialogContent>
    </DialogOverlay>
  );
}

export default Popup;
